import { createAction, createApiAction } from '@saucelabs/sl-util-redux';
import { actions as modalActions } from '@saucelabs/sl-container-modal';
import {
  actions as jobsActions,
  types as jobsTypes,
} from '@saucelabs/sl-module-jobs';

import * as types from './types';

export const toggleBuildCard = createAction(types.TOGGLE_BUILD_CARD);
export const getFailedJobs = createApiAction(
  jobsTypes.FAILED_JOBS_GET,
  jobsActions.getFailedJobs,
);

export const openBadgeConfiguratorModal = () => (dispatch) => {
  dispatch(modalActions.showModal('badgeConfigurator'));
};
